import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppLayout from './AppLayout';
import { buttonStyle, cardTitle, sectionStyle, subtitle } from './quoteStyles';

const CustomerReviewSubmit = () => {
  const navigate = useNavigate();
  const { applicationId } = useParams();
  const [application, setApplication] = useState(null);

  useEffect(() => {
    const loadApplication = async () => {
      const response = await fetch(`/api/application/${applicationId}`);
      if (!response.ok) {
        navigate('/quote/start');
        return;
      }

      const data = await response.json();
      setApplication(data);
    };

    loadApplication();
  }, [applicationId, navigate]);

  const submitRequest = async () => {
    const response = await fetch(`/api/application/${applicationId}/submit`, {
      method: 'POST',
    });

    const data = await response.json();
    if (!response.ok) {
      alert(data.error || 'Unable to submit request');
      return;
    }

    navigate(`/quote/thanks/${applicationId}`);
  };

  if (!application) return null;

  return (
    <AppLayout>
      <h1 style={cardTitle}>Review and Submit</h1>
      <p style={subtitle}>Step 4 of 4: Confirm details and submit your request.</p>

      <div style={sectionStyle}>
        <h3 style={styles.sectionTitle}>Customer Details</h3>
        <div style={styles.kv}>Name: <b>{application.customer?.fullName}</b></div>
        <div style={styles.kv}>Email: <b>{application.customer?.email}</b></div>
        <div style={styles.kv}>Phone: <b>{application.customer?.phone}</b></div>
        <div style={styles.kv}>DOB: <b>{application.customer?.dateOfBirth}</b></div>
        <div style={styles.kv}>Gender: <b>{application.customer?.gender || '-'}</b></div>
        <div style={styles.kv}>Smoker: <b>{application.customer?.smoker ? 'Yes' : 'No'}</b></div>
        <div style={styles.kv}>Occupation: <b>{application.customer?.occupation || '-'}</b></div>
      </div>

      <div style={sectionStyle}>
        <h3 style={styles.sectionTitle}>Coverage</h3>
        <div style={styles.kv}>Product: <b>{application.productType}</b></div>
        <div style={styles.kv}>Sum insured: <b>${application.coverage?.sumInsured}</b></div>
        <div style={styles.kv}>Payment: <b>{application.coverage?.paymentFrequency}</b></div>
        <div style={styles.kv}>Add-ons: <b>{application.coverage?.addons?.join(', ') || 'None'}</b></div>
      </div>

      <div style={styles.actions}>
        <button
          type="button"
          style={styles.backButton}
          onClick={() => navigate(`/quote/${applicationId}/coverage`)}
        >
          Back
        </button>
        <button type="button" style={buttonStyle} onClick={submitRequest}>
          Submit Quote Request
        </button>
      </div>
    </AppLayout>
  );
};

const styles = {
  sectionTitle: {
    color: '#236946',
    marginTop: 0,
  },
  kv: {
    color: '#345a46',
    marginBottom: 7,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 10,
    marginTop: 10,
  },
  backButton: {
    background: '#eff7f2',
    border: '1px solid #bdd8c7',
    borderRadius: 8,
    color: '#236946',
    cursor: 'pointer',
    fontSize: 15,
    fontWeight: 700,
    padding: '11px 18px',
  },
};

export default CustomerReviewSubmit;
